import React, { useMemo } from 'react';
import { Activity } from '../../models/activity';
import { ViewMode } from '../../models/preferences';
import { ActivityDay } from '../activity/activityDay';
import { ActivityMonth } from '../activity/activityMonth';
import { ActivityWeek } from '../activity/activityWeek';
import AppLoading from './appLoading';
import { AppLoaderBlur } from './appBlurLoader';
import { Box } from '@mui/material';

export interface ReportsViewsProps {
  activities: Activity[];
  viewMode: ViewMode;
  dateActivity: Date;
  isLoading: boolean;
  location?: string;
  onDayActivities: (activityDate: string) => void;
  onDeleteActivity?: (activity: Activity) => void;
  onEditActivity?: (activity: Activity) => void;
  onWeekActivities: (weekNumber: number) => void;
  showOnlyloggedTime?: boolean;
  employeeWorkHours?: number;
}

export function AppActivityViews({
  activities,
  viewMode,
  dateActivity,
  location,
  isLoading,
  onDayActivities,
  onDeleteActivity = () => {},
  onEditActivity = () => {},
  onWeekActivities,
  showOnlyloggedTime = false,
  employeeWorkHours,
}: ReportsViewsProps): JSX.Element {
  const isLoadingActivityCards = useMemo(
    () => isLoading && viewMode !== ViewMode.MONTH,
    [isLoading, viewMode]
  );

  return (
    <Box sx={{ width: '100%' }}>
      {isLoadingActivityCards ? (
        <AppLoading />
      ) : (
        <>
          {viewMode === ViewMode.DAY ? (
            <ActivityDay
              activities={activities}
              onDeleteActivity={onDeleteActivity}
              onEditActivity={onEditActivity}
            />
          ) : null}
          {viewMode === ViewMode.MONTH ? (
            <AppLoaderBlur isLoading={isLoading}>
              <ActivityMonth
                dateActivity={dateActivity}
                location={location}
                activities={activities}
                onSelectDay={onDayActivities}
                onSelectWeek={onWeekActivities}
                showOnlyloggedTime={showOnlyloggedTime}
                employeeWorkHours={employeeWorkHours}
              />
            </AppLoaderBlur>
          ) : null}
          {viewMode === ViewMode.WEEK ? (
            <ActivityWeek
              activities={activities}
              location={location}
              dateActivity={dateActivity}
              onSelectDay={onDayActivities}
              showOnlyloggedTime={showOnlyloggedTime}
              employeeWorkHours={employeeWorkHours}
            />
          ) : null}
          {viewMode === ViewMode.WORK_WEEK ? (
            <ActivityWeek
              activities={activities}
              location={location}
              dateActivity={dateActivity}
              onSelectDay={onDayActivities}
              showOnlyloggedTime={showOnlyloggedTime}
              isWorkWeek
              employeeWorkHours={employeeWorkHours}
            />
          ) : null}
        </>
      )}
    </Box>
  );
}
